export default __webpack_public_path__ + "static/media/chat_correct.d8aed39e.svg";